import { RootState } from "@/app/stores"
import { IProfileTemplate } from "@/shared/api/profilebuilder"
import { getProfileTemplateByRole } from "@/shared/api/profilebuilder/profilebuilder"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchUsersForm = createAsyncThunk<
    IProfileTemplate,
    void,
    { state: RootState }
>('usersProfilebuilder/fetchUsersForm', async (_, thunkAPI) => {
    try {
        const data = await getProfileTemplateByRole('users')
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})